import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const TradePage = () => (
  <div className="pt-20 sm:pt-[122px] min-h-screen bg-[#FAFAF8]" data-testid="trade-page">
    <section className="bg-white py-10 sm:py-16 border-b border-cream-dark">
      <div className="max-w-[1632px] mx-auto px-5 sm:px-8 lg:px-12">
        <h1 className="text-4xl sm:text-5xl font-display font-semibold text-[#1A1A1A] mb-4 tracking-tight">Trade Program</h1>
        <p className="text-base sm:text-lg text-gray-500 max-w-2xl font-body">
          Exclusive pricing and priority service for trade professionals.
        </p>
      </div>
    </section>

    <div className="max-w-4xl mx-auto px-5 sm:px-8 lg:px-12 py-6 sm:py-12">
      <div className="bg-white rounded-2xl p-6 sm:p-10 border border-gray-100 shadow-sm mb-8">
        <h2 className="text-2xl sm:text-3xl font-display font-semibold text-[#1A1A1A] mb-6">For Trade Professionals</h2>
        <p className="text-gray-600 leading-relaxed mb-6">
          Boss Cushions is proud to support Australian trade professionals with dedicated trade pricing and a streamlined ordering experience. Whether you're an upholsterer, interior designer, furniture maker, or fit-out specialist, our trade program is designed to help you deliver exceptional results to your clients.
        </p>

        <div className="grid sm:grid-cols-2 gap-5 mb-8">
          <div className="bg-gray-50 rounded-xl p-5">
            <h3 className="font-semibold text-[#1A1A1A] mb-2">Trade Pricing</h3>
            <p className="text-gray-600 text-sm leading-relaxed">Access exclusive wholesale pricing across our full range of custom cushions, foams, and fabric covers.</p>
          </div>
          <div className="bg-gray-50 rounded-xl p-5">
            <h3 className="font-semibold text-[#1A1A1A] mb-2">Priority Production</h3>
            <p className="text-gray-600 text-sm leading-relaxed">Trade orders are prioritised in our production queue, with faster turnaround times for bulk and recurring orders.</p>
          </div>
          <div className="bg-gray-50 rounded-xl p-5">
            <h3 className="font-semibold text-[#1A1A1A] mb-2">Dedicated Support</h3>
            <p className="text-gray-600 text-sm leading-relaxed">Get access to a dedicated trade account manager for quotes, technical advice, and order tracking.</p>
          </div>
          <div className="bg-gray-50 rounded-xl p-5">
            <h3 className="font-semibold text-[#1A1A1A] mb-2">Bulk Discounts</h3>
            <p className="text-gray-600 text-sm leading-relaxed">Additional volume discounts available for orders over 10 units. Contact us for a custom quote on large projects.</p>
          </div>
        </div>

        <h3 className="text-lg font-display font-semibold text-[#1A1A1A] mb-4">How to Apply</h3>
        <p className="text-gray-600 leading-relaxed mb-4">
          To qualify for our trade program, you must hold a valid Australian Business Number (ABN) and operate in a relevant trade or industry. Applications are reviewed within 1-2 business days.
        </p>
        <ol className="list-decimal list-inside text-gray-600 space-y-2 mb-6">
          <li>Contact us via email at <a href="mailto:trade@bosscushions.com.au" className="text-teal-600 hover:underline">trade@bosscushions.com.au</a> with your ABN and business details.</li>
          <li>Our team will verify your ABN and review your application.</li>
          <li>Once approved, you'll receive trade login credentials and pricing access.</li>
        </ol>
        <p className="text-sm text-gray-500 mb-8">
          Please note: Trade pricing is available for Australian-registered businesses only. A valid ABN is required for all trade accounts.
        </p>

        <div className="flex flex-col sm:flex-row gap-3">
          <a href="mailto:trade@bosscushions.com.au" className="inline-flex items-center justify-center gap-2 bg-teal-600 text-white font-semibold px-6 py-3 rounded-full hover:bg-teal-700 transition-colors" data-testid="trade-apply-btn">
            Apply for Trade Account
            <ArrowRight className="w-4 h-4" />
          </a>
          <Link to="/products" className="inline-flex items-center justify-center gap-2 bg-white text-gray-700 font-semibold px-6 py-3 rounded-full border border-gray-200 hover:bg-gray-50 transition-colors" data-testid="trade-browse-btn">
            Browse Products
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default TradePage;
